export default __webpack_public_path__ + "static/media/cmr.72ddecf7.svg";